<template>
    <div class="summaryBrackets">

        <div style="padding-left: 8px;">
          <Bracket v-model="this.brackets">
            <template #game="{ game }">
              <table class="bracky-round-table">
                <tr style="height: 20px;">
                  <td>
                    {{ game.player1.name }}
                  </td>
                  <td nowrap>
                    {{ game.player1.score }}
                    <i class="fas fa-award winner" v-if="game.player1.winner"/>
                  </td>
                </tr>
                <tr style="height: 20px;">
                  <td>
                    {{ game.player2.name }}
                  </td>
                  <td nowrap>
                    {{ game.player2.score }}
                    <i class="fas fa-award winner" v-if="game.player2.winner"/>
                  </td>
                </tr>
              </table>
            </template>
          </Bracket>
        </div>

    </div>
</template>

<style>
.summaryBrackets, h2 {
    color: black !important;
    font-size: 0.8em;
}
.bracky-round-table {
    width: 100%; 
    margin: 8px;
}
</style>

<script>
import Bracket from "bracky";

export default {
    name: "SummaryBrackets",
    props: {
        brackets: []
    },
    components: {
        Bracket
    },  
}
</script>